module.exports = __webpack_public_path__ + "static/media/3_col_4.ee1efbb9.jpg";